import { OrdersState } from "../types";

export const bookingStates: Partial<OrdersState> = {
	orderBookingData: {
		dt_start: '',
		duration: 0,
		participants_count: 0,
		notes: '',
		prepayment_amount: '',
		hold_resources: false,
		person: {
			tags: [],
			name: '',
			phone: '',
			notes: '',
			visits: 0,
			cancelled: 0,
			dt_last_visit: '',
		},
		resources: [],
		tags: [],
		bypass: false,
	},
	orderBookingDataInitial: null,
	bookingThreadMod: false,
	bookingApplicationMod: false,
  bookingIsNew: false,
  bookingIsEdit: false,
  toBookingButtonDisabled: false,
};